import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs/operators';

import { LoaderService } from '@core/services/loader/loader';

export function loaderInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  const loaderService = inject(LoaderService);
  loaderService.setLoading(true);
  return next(req).pipe(
    finalize(() => {
      loaderService.setLoading(false);
    })
  );
}
